import * as A from '../types/actions';

export const increaseScale: A.IncreaseScale['type'] = 'SCALE:INCREASE_SCALE';
export const decreaseScale: A.DecreaseScale['type'] = 'SCALE:DECREASE_SCALE';
export const setScale: A.SetScale['type'] = 'SCALE:SET_SCALE';
